<template>
    <div class="warpper">
        <div class="about-container flex flex-wrap justify-between">
            <div v-for="(item,index) in abouts" :key="item.value" :class="abouts.length % 2 === 1 && index === 0 ? 'max' :''"
                 class="item-about">
                <div class="page-classify flex align-center"><i class="iconfont icon-jichuguanli"></i>{{
                        item.typeName
                    }}
                </div>
                <div class="flex flex-wrap justify-between">
                    <div v-for="child in item.list" :key="child.id" class=" margin-top-sm">
                        <router-link :to="'/member/ship?type='+ child.id" class="item-title flex align-center">
                            <i :class="child.icon" class="iconfont"></i>{{ child.title }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex">
            <div class="info-container flex flex-direction">
                <div class="page-classify flex align-center"><i class="iconfont icon-tongzhi1"></i>通知公告</div>
                <empty v-if="notices.length === 0" :type="4" size="min" style="width: 300px;margin: 0 auto"/>
                <div v-for="(item,index) in notices" :key="index"
                     class="item-notice flex flex-direction justify-between" @click="toNoticeDetail(item.id)">
                    <div class="title ovHide">{{ item.title }}</div>
                    <div class="content ovHide">{{ item.content }}</div>
                    <div class="flex align-center">
                        <div :class="{ed:item.is_read ===1}" class="read">{{ item.is_read === 0 ? '未读' : '已读' }}</div>
                        <div v-if="item.feedback" :class="{yellow:item.is_feedback ===1}" class="time">
                            {{ item.is_feedback === 0 ? '未反馈' : '已反馈' }}
                        </div>
                        <div class="time">{{ item.add_time }}</div>
                    </div>
                </div>
                <router-link class="link-more" to="/member/notice">查看更多<i class="el-icon-arrow-right"></i></router-link>
            </div>
            <notice-detail-dialog :detailDialogVisible="noticeDetailDialogVisible" :nid="cur_nid"
                                  @watchState="watchState"></notice-detail-dialog>
            <div class="info-container  margin-left-sm flex flex-direction flex-sub">
                <div class="flex align-center">
                    <div :class="{un:classify === 2}" class="page-classify flex align-center" @click="classify = 1"><i
                        class="iconfont icon-tongzhi"></i>机构动态
                    </div>
                    <div :class="{un:classify === 1}" class="page-classify last flex align-center"
                         @click="classify = 2"><i class="iconfont icon-jiangzhang"></i>活动会议
                    </div>
                </div>

                <div v-show="classify === 1" class="flex flex-direction flex-sub">
                    <empty v-if="dynamics.length === 0" :type="1" size="min" style="width: 300px;margin: 0 auto"/>

                    <div v-for="(item,index) in dynamics" :key="index" class="item-notice flex"
                         @click="toActiveDetail(item.id)">
                        <el-image :src="item.thumb" class="image flex-shrink" fit="cover"></el-image>
                        <div class="flex flex-direction justify-between flex-sub margin-left-sm overflow-hidden">
                            <div class="title ovHide">{{ item.title }}</div>
                            <div class="content ovHide2">
                                {{ item.content }}
                            </div>
                            <div class="time">{{ item.create_time }}</div>
                        </div>
                    </div>
                </div>
                <active-detail-dialog :aid="cur_aid" :detailDialogVisible="activeDetailDialogVisible"
                                      @watchState="watchState"></active-detail-dialog>
                <div v-show="classify === 2" class="flex flex-direction flex-sub">
                    <empty v-if="meetings.length === 0" :type="0" size="min" style="width: 300px;margin: 0 auto"/>

                    <div v-for="(item,index) in meetings" :key="index" class="item-notice active flex">
                        <img v-if="item.xianshangxianxia === 1" class="tag" src="../../../assets/img/xianxia.png"/>
                        <img v-else class="tag" src="../../../assets/img/xianshang.png"/>
                        <div class="image-container flex-shrink">
                            <el-image :src="item.haibao" class="image"></el-image>
                            <div class="apply-total">已报名 {{ item.user_num }}人</div>
                        </div>
                        <div class="flex flex-direction justify-between margin-left-sm flex-sub overflow-hidden">
                            <div class="flex align-center">
                                <span v-if="item.kindname" class="classify flex-shrink">{{ item.kindname }}</span>
                                <div class="title ovHide">
                                    {{ item.title }}
                                </div>
                            </div>
                            <div class="time">时间：{{ item.starttime }} - {{ item.endtime }}</div>
                            <div class="time">主办方：{{ item.holdhost }}</div>
<!--                            <div class="time">-->
<!--                                地点：{{ item.sheng === item.shi ? item.shi : item.sheng }}{{-->
<!--                                    item.shi === '直辖市' ? '' : item.shi ===-->
<!--                                    item.sheng ? "" : item.shi-->
<!--                                }}{{ item.qu }}{{ item.address }}-->
<!--                            </div>-->
                        </div>
                        <div class="item-operate">
                            <a v-if="item.state === 1" :href="`${web_yhb_detail}${item.id}`" class="to-apply"
                               target="_blank">去报名</a>
                            <a v-else :href="`${web_yhb_detail}${item.id}`" class="to-apply"
                               target="_blank">查看详情</a>
                        </div>
                    </div>
                </div>
                <router-link :to="classify === 1?'/member/active':'/member/metting'" class="link-more">查看更多<i
                    class="el-icon-arrow-right"></i></router-link>
            </div>
        </div>

        <div class="info-container margin-top-sm flex flex-direction match flex-sub">
            <div class="page-classify flex align-center"><i class="iconfont icon-tongzhi1"></i>机构介绍</div>
            <div class="orgznie-info" v-html="orginizInfo.morgdesc">
            </div>
        </div>
    </div>
</template>

<script>
import {web_yhb_member_detail} from '@/utils/const'
import {reg_html} from '@/utils/rules'
import {YHB_URL} from '@/config/index'
import {getActives, getArticleList, getMeeting, getNotice, getOrganizInfo} from '@/api/member'
import {zhDate} from '@/utils/utils'
import NoticeDetailDialog from "@/components/NoticeDetailDialog.vue";
import ActiveDetailDialog from "@/components/ActiveDetailDialog.vue";

export default {
    components: {NoticeDetailDialog, ActiveDetailDialog},
    name: "index",
    data() {
        return {
            abouts: [],
            web_yhb_detail: web_yhb_member_detail,
            notices: [],
            classify: 1,
            dynamics: [],
            meetings: [],
            orginizInfo: '',

            cur_nid: 0,
            noticeDetailDialogVisible: false,
            cur_aid: 0,
            activeDetailDialogVisible: false
        }
    },
    created() {
        this.$emit('setIndex', [0], '首页')
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        //  页面加载时请求
        async init() {
            let _notice = await getNotice()
            if (_notice.status === 200) {
                _notice.data.map(item => {
                    item.add_time = zhDate(item.add_time * 1000)
                    item.content = item.content.replace(reg_html, '').replace(/&nbsp;/ig, '')
                })
                this.notices = _notice.data
            }
            let _dynamic = await getActives('', 1, 3)
            if (_dynamic.status === 200) {
                _dynamic.data.data.map(item => {
                    item.content = item.content.replace(reg_html, '').replace(/&nbsp;/ig, '')
                })
                this.dynamics = _dynamic.data.data
            }
            let _meeting = await getMeeting()
            if (_meeting.status === 200) {
                _meeting.data.map(item => {
                    item.haibao = YHB_URL + item.haibao
                    item.starttime = zhDate(item.starttime * 1000, 2)
                    item.endtime = zhDate(item.endtime * 1000, 2)
                })
                this.meetings = _meeting.data
            }
            let _data = await getOrganizInfo()
            if (_data.status === 200) {
                this.orginizInfo = _data.data
            }
            _data = await getArticleList()
            if (_data.status === 200) {
                this.abouts = _data.data
            }
        },
        toNoticeDetail(id) {
            this.cur_nid = id
            this.noticeDetailDialogVisible = true;
        },
        toActiveDetail(id) {
            this.cur_aid = id
            this.activeDetailDialogVisible = true;
        },
        watchState() {
            this.noticeDetailDialogVisible = false;
            this.activeDetailDialogVisible = false;
        },
    }
}
</script>

<style lang="scss" scoped>
.warpper {
    display: flex;

    .page-classify {
        font-size: 20px;
        font-weight: bold;
        color: #0a2240;

        &.un {
            color: #7889a4;
            cursor: pointer;
        }

        &.last {
            margin-left: 68px;
            position: relative;

            &:before {
                position: absolute;
                content: '';
                width: 2px;
                height: 18px;
                background-color: #b7c0d0;
                top: 0;
                left: -34px;
            }
        }

        i {
            font-size: 22px;
            margin-right: 6px;
        }
    }

    .link-more {
        font-size: 12px;
        color: #4b648a;
        text-align: center;
        margin-top: 8px;

        i {
            color: #4b648a;
        }
    }

    .info-container {
        width: 372px;
        min-height: 300px;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 18px 20px;

        &.match {
            width: 100%;
        }

        .orgznie-info {
            min-height: 260px;
            word-break: break-word;
            background-color: #f3f7fb;
            border-radius: 10px;
            font-size: 16px;
            line-height: 24px;
            color: #0a2240;
            text-align: justify;
            text-indent: 2rem;
            padding: 20px;
            margin-top: 20px;
        }

        .item-notice {
            width: 100%;
            height: 107px;
            background-color: #f3f7fb;
            border-radius: 10px;
            margin-top: 20px;
            padding: 11px 20px;
            cursor: pointer;
            position: relative;

            .tag {
                position: absolute;
                top: 0;
                right: 0;
            }

            &.active {
                .item-operate {
                    display: none;
                }

                &:hover {
                    position: relative;

                    .item-operate {
                        position: absolute;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: #00000033;

                        .to-apply {
                            width: 80px;
                            height: 80px;
                            line-height: 80px;
                            border-radius: 80px;
                            text-align: center;
                            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                            linear-gradient(#ff9600, #ff9600);
                            background-blend-mode: normal, normal;
                            color: #ffffff;
                            font-size: 16px;
                            cursor: pointer;
                        }
                    }
                }
            }

            .image {
                width: 116px;
                height: 88px;
                border-radius: 10px;
            }

            .image-container {
                width: 116px;
                height: 88px;
                border-radius: 10px;
                position: relative;

                .apply-total {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;
                    background-color: #00000022;
                    font-size: 10px;
                    color: #ffffff;
                    border-radius: 0 0 10px 10px;
                }
            }

            .title {
                font-size: 20px;
                font-weight: bold;
                color: #0a2240;
            }

            .classify {
                background-color: #ff9600;
                border-radius: 9px;
                padding: 3px 6px;
                font-size: 14px;
                color: #fefeff;
                margin-right: 6px;
            }

            .content {
                width: 100%;
                font-size: 14px;
                color: #7889a4;
            }

            .read {
                width: 39px;
                height: 16px;
                line-height: 16px;
                text-align: center;
                background-color: #ff9600;
                border-radius: 8px;
                font-size: 12px;
                margin-right: 8px;
                color: #ffffff;

                &.ed {
                    background-color: #8ba2c6;
                }
            }

            .time {
                font-size: 14px;
                color: #7889a4;
                margin-right: 8px;

                &.yellow {
                    color: #ff9600;
                }
            }
        }
    }

    .about-container {
        .item-about {
            width: 49%;
            background-color: #ffffff;
            border-radius: 10px;
            padding: 18px 20px;
            margin-bottom: 20px;

            &.max {
                width: 100%;

                .item-title {
                    width: 306px;
                }
            }

            .item-title {
                width: 216px;
                height: 70px;
                background-color: #f3f7fb;
                border-radius: 10px;
                border: solid 1px #d1deef;
                font-size: 18px;
                color: #0a2240;
                padding: 0 16px;

                i {
                    font-size: 20px;
                    margin-right: 6px;
                }

                &:hover {
                    cursor: pointer;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#0a2240, #0a2240);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    border: none;
                }

            }
        }
    }
}
</style>
